<div class="sync-card" [class.sync-card--expanded]="expanded">
  <div class="sync-card__header" (click)="toggle()">
    <div class="sync-card__info">
      <button
        type="button"
        mat-icon-button
        class="sync-card__chevron-btn"
        [attr.aria-expanded]="expanded"
        [attr.aria-label]="(expanded ? 'Contraer ' : 'Expandir ') + state.fileNumber"
        (click)="toggle(); $event.stopPropagation()"
      >
        <i-tabler
          name="chevron_right"
          class="sync-card__chevron"
          [class.sync-card__chevron--open]="expanded"
        ></i-tabler>
      </button>
      <i-tabler name="file" class="sync-card__icon"></i-tabler>
      <span class="sync-card__file">{{ state.fileNumber }}</span>
      <span class="sync-card__sep">°</span>
      <span>{{ state.agencia }}</span>
      <span class="sync-card__sep">°</span>
      <span>{{ state.usuario }}</span>
      <span class="sync-card__badge">{{ state.serviceStates.length }}</span>
    </div>

    <div class="sync-card__mass-controls" (click)="$event.stopPropagation()">
      <ng-content select="[massControls]"></ng-content>
    </div>
  </div>

  <div class="sync-card__body" *ngIf="expanded">
    <app-mass-os-itinerary-services-sync
      [state]="state"
      [step]="step"
      (dateChange)="onServiceDateChange($event)"
      (codeChange)="onServiceCodeChange($event)"
    ></app-mass-os-itinerary-services-sync>
  </div>
</div>
